export const setMovies = (state, payload) => {
    state.movies = payload;
};

export const setMovie = (state, payload) => {
    state.movie = payload;
};